import { GroupedSalesItem } from "../models/core/chart-interfaces";

const today = new Date();

const getPastDate = (daysAgo: number): string => {
  const d = new Date(today);
  d.setDate(d.getDate() - daysAgo);
  return d.toISOString().slice(0, 10);
};

export const EMPTY_GROUPED_SALES_ITEMS: GroupedSalesItem[] = Array.from({ length: 7 }).map((_, i) => ({
  date: getPastDate(6 - i),
  ecommerce: 0,
  directa: 0,
  free: 0,
}));
